import { Box, useTheme } from "@mui/material";
import { Insights } from "@mui/icons-material";

interface InsightMarkProps {
  /** Square edge length in px. Icon scales with it. */
  size?: number;
}

/**
 * The flat Insight AI identity mark — used wherever the assistant "speaks"
 * (message turns, thinking indicator, empty-state hero) so users always know
 * which voice they are reading. Green tint follows the house chip idiom.
 */
export const InsightMark = ({ size = 26 }: InsightMarkProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: `${Math.max(6, Math.round(size * 0.28))}px`,
        backgroundColor:
          theme.palette.mode === "dark" ? "rgba(34, 197, 94, 0.15)" : "rgba(34, 197, 94, 0.1)",
        border:
          theme.palette.mode === "dark"
            ? "1px solid rgba(34, 197, 94, 0.3)"
            : "1px solid rgba(34, 197, 94, 0.2)",
      }}
    >
      <Insights sx={{ fontSize: Math.round(size * 0.58), color: "#22c55e" }} />
    </Box>
  );
};
